<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import { faPlus, faTrashAlt, faSave } from '@fortawesome/free-solid-svg-icons'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import { ProductInvoicesRepository } from '../../modules/posApi/stock/product-invoices/product-invoices.repository'
    import { ProductInvoicesService } from '../../modules/posApi/stock/product-invoices/product-invoices.service'
    import { ProductInvoice } from '../../modules/posApi/stock/product-invoices/product-invoice'
    import StockInFormItems from './stock-in-form-items.svelte'
    import type { ProductMovement } from '../../modules/posApi/stock/product-movements/product-movement'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'

    const dispatch = createEventDispatcher()

    const rep = new ProductInvoicesRepository()
    const service = new ProductInvoicesService(rep)

    // const compR = new CompaniesRepository()
    // const compS = new CompaniesService(compR)
    // let users: User[] = []

    export let productInvoiceId: string = null

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)
    let persons: Person[] = []

    let show = false
    let entity: ProductInvoice = new ProductInvoice()
    let createdAt: Date = new Date()
    let newService: boolean = false
    let newPayment: boolean = false

    let valuePending = 0

    onMount(async () => {
        if (productInvoiceId) {
            await loadEntity(productInvoiceId)
        } else {
            newEntity()
        }
    })

    async function loadEntity(id: string) {
        try {
            show = true
            entity = new ProductInvoice()
            entity = await service.getOne(id)
            createdAt = new Date(entity.createdAt)
            entity.person = await personsS.getOne(entity.personId)
            // entity.user = users.find((el) => el.userId === entity?.userId)
            // for (let service of entity.services) {
            //     service.user = users.find((el) => el.userId === service?.userId)
            // }
            console.log('invoice', entity)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new ProductInvoice()
        entity.createdAt = new Date(createdAt)
        entity.productMovement = []
        // let store: Store = new Store()
        // entity.user = users.find((el) => el.userId === store.token.userId)
    }

    async function saveEntity() {
        upsertEntity()
    }

    async function upsertEntity() {
        try {
            if (show) return
            show = true
            if (!createdAt) {
                evaluateError('Informe data e hora de lançamento válidos')
                return false
            }
            entity.productMovement = entity.productMovement.filter((el) => !!el)
            let prodMov: ProductMovement[] = []
            for (let p of entity.productMovement) {
                p.service = undefined
                p.type = 'in'
                prodMov.push(p)
            }

            const dto: Partial<ProductInvoice> = {
                productInvoiceId: entity.productInvoiceId || undefined,
                createdAt: new Date(createdAt),
                notes: entity.notes,
                personId: entity.person?.personId,
                productMovement: prodMov,
                acquiredAt: new Date(createdAt),
                invoiceNumber: entity.invoiceNumber,
            }

            if (!validateDto(dto)) return false
            await service.upsert(dto)
            window.api.users.statistics.tick('stock.movement')
            dispatch('change')
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function validateDto(dto: Partial<ProductInvoice>) {
        if (!dto.personId) {
            evaluateError('Selecione o fornecedor')
            return false
        }
        if (dto.productMovement.length === 0) {
            evaluateError('Você deve informar ao menos um produto')
            return false
        }
        return true
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity.productInvoiceId)
            dispatch('change')
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newServiceItem() {
        newService = true
    }

    async function serviceAdded(event) {
        entity.productMovement.push(event.detail)
        entity.productMovement = entity.productMovement
        newService = false
        console.log('product-added')
    }

    function serviceClosed() {
        newService = false
    }

    function evaluateError(error) {
        window.error(error)
    }
</script>

<div class="root m-bottom-sm">
    <Zact>
        <div class="spacer h-mobile" />
        {#if window.store.token.permissions.stock.inputs.write}
            {#if !!entity.productInvoiceId}
                <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
            {/if}
            <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
        {/if}
    </Zact>
    <div class="grid-form">
        <div class="config-box mt-2 mx-2">
            <ZContainer>
                <ZContainerCol size={4} sizeM={12}>
                    <ZentitySelect fonte="pessoa" label="Fornecedor" bind:value={entity.person} />
                </ZContainerCol>
                <ZContainerCol size={4} sizeM={12}>
                    <Zinput type="datetime" label="Data da compra" bind:value={createdAt} />
                </ZContainerCol>
                <ZContainerCol size={4} sizeM={12}>
                    <Zinput label="Anotações" bind:value={entity.notes} />
                </ZContainerCol>
            </ZContainer>
        </div>

        <div class="row mt-2-sm mx-0">
            <div class="col config-box">
                <div class="-title h-mobile">Produtos</div>
                {#if entity.productMovement?.length > 0}
                    <div class="grid-head h-mobile">
                        <div class="row">
                            <div class="col">Item</div>
                            <div class="col-md-1 text-end">Valor Unit</div>
                            <div class="col-md-1 text-end">Qtde</div>
                            <div class="col-md-1 text-end">Total</div>
                            <div class="col-md-2" />
                        </div>
                    </div>
                    <div class="grid-body">
                        {#each entity.productMovement as item}
                            <StockInFormItems on:cancel={serviceClosed} on:added={serviceClosed} bind:productMovementItem={item} />
                        {/each}
                    </div>
                {/if}
                <div class="mt-2 mb-2">
                    {#if newService}
                        <StockInFormItems on:cancel={serviceClosed} on:added={serviceAdded} />
                    {:else}
                        <div class="add-item">
                            <Zbutton icon={faPlus} label="Adicionar produto..." on:click={newServiceItem} />
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .row {
        padding: 0px 16px;
    }
    .config-box .-title {
        font-size: 20px;
    }
    @media (max-width: 900px) {
        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .add-item {
            text-align: center;
        }
        .add-item {
            text-align: center;
        }
        .config-box {
            margin-top: 16px;
        }
    }
</style>
